//polyfill
import "babel-polyfill";

import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { GlobalNav, FooterNav } from "../nav/Nav";
import { Homepage } from "./home";
import { ProductGroup } from "./allProducts";
import { ProductDetail } from "./product";
import { AllRecipes } from "./allRecipes";
import { RecipeDetail } from "./recipe";
import { PrivacyPolicy } from "./privacyPolicy";
import throttle from "es6y-throttle/dist/throttle";
import { Helmet } from "react-helmet"; //metadata manager
import { AnalyzeBrowser } from "../helpers/helpers";

//style
import "../css/master.css";

//images
import logo from "../img/logo.svg";

//data
import { Config } from "../json/config";

class App extends Component {
  constructor(props) {
    super(props);

    this.onScroll = this.onScroll.bind(this);

    const screenWidth = window.innerWidth;
    window.isTablet = false;
    window.isMobile = false;
    if (screenWidth > 700 && screenWidth < 900) {
      window.isTablet = true;
    }
    if (screenWidth < 700) {
      window.isMobile = true;
    }

    //browser detection
    AnalyzeBrowser((browser, version) => {
      document
        .getElementsByTagName("body")[0]
        .setAttribute("data-browser", `${browser}-${version}`);
    });
  }

  /*
        scroll function, occurs on scroll with throttling
    */
  onScroll() {
    window.scrollTop =
      window.pageYOffset ||
      (document.documentElement || document.body.parentNode || document.body)
        .scrollTop;

    if (window.scrollTop > 200) {
      if (!this.logo.classList.contains("small")) {
        this.logo.classList.add("small");
      }
    } else {
      this.logo.classList.remove("small");
    }
  }

  render() {
    //const year = new Date().getFullYear();

    /*
            Scroll listener
        */
    window.addEventListener("scroll", throttle(() => this.onScroll(), 300));

    return (
      <Router>
        <div className="globalWrap">
          <Helmet>
            <title>{Config.title}</title>
          </Helmet>
          <header className="globalHeader">
            <div
              className="header-branding"
              ref={el => {
                this.logo = el;
              }}
            >
              <Link
                to="/"
                data-section="home"
                data-subsection="home"
                data-pagetype="home"
              >
                <img
                  className="header-logo"
                  src={logo}
                  alt="Food Network Kitchen Inspirations logo"
                />
              </Link>
            </div>
            <GlobalNav />
          </header>
          <div className="mainContent">
            <main id="pageContent">
              <Route exact path="/" component={Homepage} />
              <Route exact path="/products/:group" component={ProductGroup} />
              <Route path="/products/:group/:name" component={ProductDetail} />
              <Route exact path="/recipes" component={AllRecipes} />
              <Route exact path="/recipes/:name" component={RecipeDetail} />
              <Route exact path="/privacy" component={PrivacyPolicy} />
            </main>
          </div>
          <footer className="globalFooter background-dark padding-x-large">
            <div className="flex justify-center vertical-center">
              <FooterNav />
              <div className="footer-branding text-align-center">
                <Link to="/">
                  <img
                    src={logo}
                    alt="Food Network Kitchen Inspirations logo"
                  />
                </Link>
              </div>
            </div>
          </footer>
        </div>
      </Router>
    );
  }
}

export default App;

export class BackButton extends Component {
  static contextTypes = {
    router: () => true // replace with PropTypes.object if you use them
  };

  render() {
    return (
      <button
        className="button-back"
        onClick={this.context.router.history.goBack}
      >
        Back
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/App.js